import React from 'react'
import ReportSection from "../../components/Food_Repot/ReportSection"
import { useState,useEffect } from "react";
import url from "../../config/axios";
import { useParams } from "react-router-dom";
const TransportReportSection = () => {
  const [suggestdata, setSuggestdata] = useState();
  const {id} =useParams();

  const suggestdatta = () => {
    url
      .get(`reportshop/?shopId=${id}`)
      .then(async (res) => {

        setSuggestdata(res?.data?.reports);
      });
  };

  useEffect(() => {
    suggestdatta();
  }, []);
  return (
    <ReportSection title="Reports" suggestdata={suggestdata} id={id}/>
  )
}

export default TransportReportSection;